import { render } from "./FrontLayout.vue?vue&type=template&id=3482df4c&scoped=true"
import script from "./FrontLayout.vue?vue&type=script&lang=js"
export * from "./FrontLayout.vue?vue&type=script&lang=js"

import "./FrontLayout.vue?vue&type=style&index=0&id=3482df4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3482df4c"]])

export default __exports__